import {Actions, IAction} from "login/actions";
import {IAuth, LoginChannel} from "StateInterface";
import {getUpdateEmailResponse} from "login/utils";
import {logBranchEvent, setUserId} from "analytics/branch";
import {getAuthExternalStatus, resetAuth} from "service";

export enum LoginStatus {
    SUCCESS = "SUCCESS",
    ACCESS_DENIED = "ACCESS_DENIED",
}

export enum LoginMode {
    V1 = "v1",
    V2 = "v2",
    SSO = "SSO",
}

export interface IState {
    userId: number;
    auth: IAuth;
    errMessage: any;
    status: LoginStatus;
    loading: boolean;
    authExt: any;
    userFound: string;
    requestId: string;
    emailUpdateResponse: {
        status: string;
        msg: string;
    };
    currentFlowChannel: LoginChannel;
    isAndroid: boolean;
    apiVersion: number;
    loginMode: LoginMode;
    isPartnerAndroid: boolean;
}

export const defaultState: IState = {
    userId: null,
    auth: null,
    errMessage: null,
    status: null,
    loading: true,
    authExt: null,
    userFound: null,
    requestId: null,
    emailUpdateResponse: {
        status: null,
        msg: null,
    },
    currentFlowChannel: null,
    isAndroid: false,
    apiVersion: null,
    loginMode: LoginMode.V1,
    isPartnerAndroid: false,
};

export default function login(state = defaultState, action: IAction) {
    // TODO: handle this action body error
    const statusCode = action && action.response && action.response.statusCode;
    switch (action.type) {
        case Actions.SET_ANDROID:
            return {
                ...state,
                isAndroid: true,
            }
        case Actions.REQUEST_SIGN_IN:
            return {
                ...state,
                loading: !getAuthExternalStatus(),
                loginMode: LoginMode.V1,
            };
        case `${Actions.REQUEST_SIGN_IN}_SUCCESS`:
            setUserId(action.body.userId);
            if (action.body.existing === false) {
                logBranchEvent("SIGN_UP", {userId: action.body.userId});
            }
            return {
                ...state,
                auth: action.body,
                status: LoginStatus.SUCCESS,
                loading: false,
            };
        case `${Actions.REQUEST_SIGN_IN}_FAILURE`:
            return {
                ...state,
                errMessage: action.error,
                status: LoginStatus.ACCESS_DENIED,
                loading: false,
            };
        case Actions.RESET_AUTH:
            return {
                ...state,
                status: null,
                auth: null,
            };
        case Actions.SET_CURRENT_FLOW_CHANNEL:
            return {
                ...state,
                currentFlowChannel: action.body,
            };
        case Actions.SET_LOADING:
            return {
                ...state,
                loading: action.value,
            };
        case Actions.SET_EXT_AUTH_PARAM:
            const value = action.body;
            delete value.id_token;
            return {
                ...state,
                authExt: value,
            };
        case Actions.REQUEST_OTP_REGISTERED:
            return {
                ...state,
                loading: true,
            };
        case `${Actions.REQUEST_OTP_REGISTERED}_SUCCESS`:
            return {
                ...state,
                userFound: "SUCCESS",
                requestId : action.body.requestId,
                loading: false,
            };
        case `${Actions.REQUEST_OTP_REGISTERED}_FAILURE`:
            return {
                ...state,
                userFound: "FAILURE",
                loading: false,
            };
        case Actions.REQUEST_UPDATE_EMAIL:
            return {
                ...state,
                loading: true,
            };
        case `${Actions.REQUEST_UPDATE_EMAIL}_SUCCESS`:
            resetAuth();
            return {
                ...state,
                emailUpdateResponse: getUpdateEmailResponse(statusCode),
                loading: false,
            };
        case `${Actions.REQUEST_UPDATE_EMAIL}_FAILURE`:
            resetAuth();
            return {
                ...state,
                emailUpdateResponse: getUpdateEmailResponse(statusCode),
                loading: false,
            };
        case `${Actions.CLEAR_UPDATE_EMAIL_PROPS}`:
            return {
                ...state,
                emailUpdateResponse: {status: null, msg: null},
                userFound: null,
            };
        case Actions.SET_API_VERSION:
            return {
                ...state,
                apiVersion: action.body.version,
            }
        case Actions.SET_TWO_FACTOR_AUTH:
            return {
              ...state,
              auth: action.body,
              status: LoginStatus.SUCCESS,
              loading: false,
              loginMode: LoginMode.V2,
            };
        case Actions.PARTNER_SIGN_IN:
            setUserId(action.body.userId);
            return {
                ...state,
                auth: action.body,
                status: LoginStatus.SUCCESS,
                loading: false,
                loginMode: LoginMode.SSO,
            };
        case Actions.SET_ACCESS_TOKEN_LOGIN:
            return {
                ...state,
                auth: action.body,
                status: LoginStatus.SUCCESS,
                loading: false,
                loginMode: LoginMode.SSO,
            };
        case Actions.SET_PARTNER_ANDROID:
            return {
                ...state,
                isPartnerAndroid: true,
                loginMode: LoginMode.SSO,
            };
        default:
            return state;
    }
}
